import $ from 'jquery';
import type from './libs/type';

let $form = $('.feedback-form');
let $informerSuccess = $('.informer._success');

const initForm = function()
{
    if(!$form.length) {
        return;
    }

    let isBusy = false;
    let $submitButton = $form.find('button:submit');
    let defaultSubmitLabel = $submitButton.text();
    let loadingSubmitLabel = $submitButton.data('busy-label');
    //button__wrapper
    $form
        .on('blur', 'input, textarea', function(e) {
            e.preventDefault();

            $(this)[this.value ? 'addClass' : 'removeClass']('_filled');
        })
        .on('submit', function(e) {
            e.preventDefault();

            if(isBusy) {
                return;
            }

            isBusy = true;

            if(loadingSubmitLabel) {
                $submitButton.find('.button__wrapper').text(loadingSubmitLabel);
            }

            $form.find('.feedback-form__error').remove();

            $.ajax({
                url: $form.attr('action'),
                type: $form.attr('method') || 'post',
                data: $form.serialize(),
                dataType: 'json',
                success: function(response) {
                    if(type.isNotEmptyPlainObject(response)) {
                        if(response.status) {
                            $informerSuccess.show();

                            $form.hide();
                            $form.get(0).reset();

                            if(typeof(document.body.scrollIntoView) === 'function') {
                                let header = document.querySelector('.page-header');
                                if(header) {
                                    header.scrollIntoView({
                                        block: "start", behavior: "smooth"
                                    });
                                }
                            }
                        }
                    }

                    isBusy = false;
                    $submitButton.find('.button__wrapper').text(defaultSubmitLabel);
                },
                error: function(response) {
                    if(type.isNotEmptyPlainObject(response.responseJSON.errors)) {
                        const errors = response.responseJSON.errors;
    
                        Object.keys(errors).forEach(name => {
                            let $input = $form.find('[name="'+name+'"]');
                            let $parent = $input.closest('.feedback-form__row');
                            let error = `<p class="feedback-form__error">${errors[name][0]}</p>`;

                            if($parent.length) {
                                $parent.after(error);
                            }
                            else {
                                if($input.is(':checkbox')) {
                                    $input.closest('.feedback-form__row-checkbox__label').after(error);
                                }

                                if(name === 'g-recaptcha-response') {
                                    $('.feedback-form__captcha').append(error);
                                }
                            }
                        });

                        if(window.grecaptcha) {
                            window.grecaptcha.reset();
                        }
                    }

                    isBusy = false;
                    $submitButton.find('.button__wrapper').text(defaultSubmitLabel);
                }
            });
        });
}

const init = function() {

    initForm()

}

export default init;